import {createContext, type ReactNode, useContext, useState} from 'react';

interface AutoDeliveryDcxContextValue {
    detailsRefetchDisabled: boolean;
    setDetailsRefetchDisabled: (value: boolean) => void;
    openRescheduleRequested: boolean;
    setOpenRescheduleRequested: (value: boolean) => void;
}

const AutoDeliveryDcxContext = createContext<AutoDeliveryDcxContextValue | null>(null);

export const AutoDeliveryDcxProvider = ({children}: {children: ReactNode}) => {
    const [detailsRefetchDisabled, setDetailsRefetchDisabled] = useState(false);
    const [openRescheduleRequested, setOpenRescheduleRequested] = useState(false);

    return (
        <AutoDeliveryDcxContext.Provider
            value={{
                detailsRefetchDisabled,
                setDetailsRefetchDisabled,
                openRescheduleRequested,
                setOpenRescheduleRequested,
            }}
        >
            {children}
        </AutoDeliveryDcxContext.Provider>
    );
};

export const useAutoDeliveryDcxContext = () => {
    const context = useContext(AutoDeliveryDcxContext);

    if (!context) {
        throw new Error('useAutoDeliveryDcxContext must be used within AutoDeliveryDcxProvider');
    }

    return context;
};
